import { Worksheet } from "exceljs";
import { RowData } from "../../../../types";
import { str } from "../../components/custom-renderers/inventory-buildings/utils/fieldUtils";

export const populateWorksheet = (
  worksheet: Worksheet,
  rows: RowData[],
): void => {
  if (rows.length === 0) {
    return;
  }

  const headers = Object.keys(rows[0]);

  worksheet.columns = headers.map((header) => ({
    header,
    key: header,
  }));

  rows.forEach((row) => {
    worksheet.addRow(row);
  });

  styleHeader(worksheet);
  autoFitColumns(worksheet);
};

export const styleHeader = (worksheet: Worksheet): void => {
  const headerRow = worksheet.getRow(1);

  headerRow.font = {
    bold: true,
  };

  headerRow.alignment = {
    vertical: "middle",
  };
};

export const autoFitColumns = (worksheet: Worksheet): void => {
  worksheet.columns.forEach((column) => {
    let maxLength = 15;

    (column.values ?? []).forEach((value) => {
      if (value == null) {
        return;
      }

      const length = str(value).length;

      maxLength = Math.max(maxLength, length + 2);
    });

    column.width = Math.min(maxLength, 50);
  });
};
